import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { delay: { type: Number, default: 400 } }

  // Dipanggil saat user MENGETIK (Input text)
  // Menggunakan delay (debounce) agar tidak request setiap huruf
  submit(event) {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.element.requestSubmit()
    }, this.delayValue)
  }

  // Dipanggil saat user MEMILIH DROPDOWN (Select)
  // Tanpa delay (0ms), langsung refresh tabel
  submitImmediate(event) {
    clearTimeout(this.timeout)
    this.element.requestSubmit()
  }
}